import Api from '../../api'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'
import { CUSTOM_JWT_STORAGE_KEY } from 'portal-modules/common/constants/keys'
import { localStorage as local } from '@entrata/utils'

// action types
const REQUEST_VALIDATE_PAYMENT =
  'rp/paymentValidationResult/REQUEST_VALIDATE_PAYMENT'
const REQUEST_VALIDATE_PAYMENT_FOR_MOBILE =
  'rp/paymentValidationResult/REQUEST_VALIDATE_PAYMENT_FOR_MOBILE'
const RECEIVE_VALIDATE_PAYMENT = 'rp/paymentValidationResult/VALIDATE_PAYMENT'
const UPDATE_RESULT = 'rp/paymentValidationResult/UPDATE_RESULT'
const HIDE_BULK_AMOUNT_SCREEN =
  'rp/bulkPaymentAmountScreen/HIDE_BULK_AMOUNT_SCREEN'
const RESET_RESULT = 'rp/bulkPaymentAmountScreen/RESET_RESULT'
const RESET_VALIDATE_PAYMENTS =
  'rp/bulkPaymentAmountScreen/RESET_VALIDATE_PAYMENTS'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_VALIDATE_PAYMENT:
      return { ...payload }
    case HIDE_BULK_AMOUNT_SCREEN:
      return { ...state, show_bulk_amount_screen: false }
    case UPDATE_RESULT:
      if (payload.from_reset !== true) {
        if (state.current_index > 0) {
          payload = {
            ...payload,
            current_index: payload.existing
              ? state.current_index
              : state.current_index + 1,
          }
        } else {
          payload = {
            ...payload,
            current_index: 1,
          }
        }
      }
      if (payload.from_reset == true) {
        return { ...payload, from_reset: false }
      } else {
        return { ...state, ...payload }
      }
    case RESET_RESULT:
      return { ...state, ...payload }
    case RESET_VALIDATE_PAYMENTS:
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestValidatePayment = createFormAction(REQUEST_VALIDATE_PAYMENT)
export const requestValidatePaymentForMobile = createFormAction(
  REQUEST_VALIDATE_PAYMENT_FOR_MOBILE,
)

export const receiveValidatePayment = payload => ({
  type: RECEIVE_VALIDATE_PAYMENT,
  payload,
})

export const updateValidatePaymentResult = payload => ({
  type: UPDATE_RESULT,
  payload,
})

export const resetValidatePaymentResult = payload => ({
  type: RESET_RESULT,
  payload,
})

export const resetValidatePayments = payload => ({
  type: RESET_VALIDATE_PAYMENTS,
  payload,
})

export const hideBulkAmountScreen = payload => ({
  type: HIDE_BULK_AMOUNT_SCREEN,
  payload,
})

// sagas
function* fetchValidatePayment(callback) {
  let responseData = []
  let storedValidatedResult = yield select(
    ({ bulkValidatePayments }) => bulkValidatePayments || {},
  )
  if (
    !storedValidatedResult ||
    !storedValidatedResult[callback.lease_id] ||
    storedValidatedResult[callback.lease_id].message !== 'Success' ||
    storedValidatedResult[callback.lease_id].amount !== callback.payment_amount
  ) {
    let payload = {
      payment_amount: callback.payment_amount,
      promise_to_pay: callback.promise_to_pay,
      agrees_to_duplicate: callback.agrees_to_duplicate,
      customer_payment_account_id: callback.customer_payment_account_id,
      lease_id: callback.lease_id,
    }
    try {
      yield call(local.set, CUSTOM_JWT_STORAGE_KEY, callback.token)
      const response = yield call(Api.postValidatePayment, payload)
      responseData[callback.lease_id] = {
        ...response,
        amount: callback.payment_amount,
        validated: true,
      }
    } catch (error) {
      if (error) {
        if (
          error?.response?.data?.code === 3133 ||
          (error?.response?.data?.code === 3134 &&
            error?.response?.data?.message?.indexOf('auto payment') !== -1)
        ) {
          responseData[callback.lease_id] = {
            error: error?.response?.data,
            message: error?.response?.data?.message,
            validated: false,
          }
          responseData['agrees_to_duplicate'] = {
            required: true,
            value: false,
            lease_id: callback.lease_id,
          }
        } else {
          responseData[callback.lease_id] = {
            error: error?.response?.data,
            message: error?.response?.data?.message || '',
            validated: false,
          }
        }
      }
    }
    storedValidatedResult = yield select(
      ({ bulkValidatePayments }) => bulkValidatePayments || {},
    )

    storedValidatedResult = {
      ...storedValidatedResult,
      ...responseData,
    }
    let validationSucceededCount = Object.values(storedValidatedResult).filter(
      ({ validated }) => true == validated,
    ).length
    responseData = {
      ...responseData,
      completed: true,
      move_to_next:
        validationSucceededCount == callback.total_index + 1 ? true : false,
      multiple_errors:
        validationSucceededCount < callback.total_index ? true : false,
      show_bulk_amount_screen:
        validationSucceededCount < callback.total_index + 1 ? true : false,
    }
    if (storedValidatedResult[callback.lease_id]) {
      callback['existing'] = true
    }

    if (
      callback?.successCallback != null &&
      callback?.errorCallback != null &&
      typeof callback.successCallback == 'function' &&
      typeof callback.errorCallback == 'function'
    ) {
      validationSucceededCount == callback.total_index + 1
        ? callback.successCallback()
        : callback.errorCallback()
    }
  }
  yield put(updateValidatePaymentResult(responseData))
}

function* resetValidatePayment({ payload }) {
  let resultData = {}
  if (payload.leaseId !== 'all') {
    let storedValidatedResult = yield select(
      ({ bulkValidatePayments }) => bulkValidatePayments || {},
    )

    Object.keys(storedValidatedResult)?.map(key => {
      if (key !== payload.leaseId)
        resultData = {
          ...resultData,
          [key]: storedValidatedResult[key],
        }
    })
    if (
      storedValidatedResult?.agrees_to_duplicate?.lease_id == payload.leaseId
    ) {
      resultData['agrees_to_duplicate'] = {}
    }
  }
  resultData = {
    ...resultData,
    from_reset: true,
  }

  yield put(updateValidatePaymentResult(resultData))
}

function* watchValidatePayment() {
  yield takeEvery(
    REQUEST_VALIDATE_PAYMENT,
    createRequestSaga(fetchValidatePayment, {
      key: 'payments',
      message: __('Validating Bulk Payments...'),
    }),
  )
}
function* watchResetValidatePayment() {
  yield takeEvery(
    RESET_RESULT,
    createRequestSaga(resetValidatePayment, {
      key: 'bulk_one_time_payments',
      message: __('Resetting Bulk Payments...'),
    }),
  )
}

function* watchValidatePaymentForMobile() {
  yield takeEvery(
    REQUEST_VALIDATE_PAYMENT_FOR_MOBILE,
    createRequestSaga(fetchValidatePayment, {
      key: 'bulk_one_time_payments',
      message: __('Validating Bulk Payments...'),
      showLoading: false,
    }),
  )
}

export const sagas = [
  watchValidatePayment,
  watchValidatePaymentForMobile,
  watchResetValidatePayment,
]
